var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterSolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8249 4.22816C17.7811 3.53111 16.7547 3.22334 15.7874 3.2518C14.7406 3.28261 13.8379 3.70519 13.1317 4.31942C12.0006 5.30323 11.3078 6.83984 11.2932 8.258C9.78475 8.20194 8.33288 7.62291 7.09193 6.81598C5.63795 5.87054 4.55538 4.66502 4.07653 3.79204C3.90717 3.48327 3.57527 3.36096 3.28859 3.40763C3.01178 3.4527 2.75755 3.6551 2.67582 3.96334C1.4882 8.44278 2.60777 13.434 5.40064 16.3905C4.79328 16.9466 3.64749 17.7426 2.00461 17.7529C1.62517 17.7553 1.35969 18.0214 1.2787 18.3033C1.19629 18.5901 1.28485 18.9725 1.62918 19.1712C5.64559 21.4887 10.4297 21.0998 14.182 19.0134C17.8875 16.953 20.6815 13.1831 20.7539 8.57253L22.6577 4.85746C22.9405 4.30542 22.4787 3.66527 21.8656 3.75972L18.8249 4.22816Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSolidStandard);
export default __webpack_public_path__ + "static/media/twitter-solid-standard.dbf4d58c29aed2e19ebb090b67bd5533.svg";
export { ForwardRef as ReactComponent };